var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Defaults } from "../../../defaults";
import moment from "moment";
import "../../../lib/accent-neutralise.js";
import $ from "jquery";
export class Mesas {
    static saveTable() {
        Defaults.Alert("Guardado");
        $(document).on("click", "#modal .close", () => {
            window.location.reload();
        });
    }
    initDatatable() {
        const filename = "Evento * - Mesas de Invitados";
        $("table").DataTable({
            dom: '<"row"<"col-3"B><"col"f>>rtip',
            buttons: [
                {
                    title: filename,
                    // @ts-ignore
                    messageTop: `Fecha: ${moment().format("DD/MMMM/YYYY hh:mma")}\r\n`,
                    extend: "pdfHtml5",
                    exportOptions: {
                        orthogonal: "export",
                        modifier: {
                            order: "index",
                        },
                    },
                    orientation: "portrait",
                    filename,
                    // @ts-ignore
                    download: "open",
                },
                {
                    text: "Nueva Mesa",
                    action: (e, dt, node, config) => __awaiter(this, void 0, void 0, function* () {
                        yield Defaults.openModal({
                            title: "Nueva Mesa",
                            url: "mesas/nuevo",
                        });
                    }),
                },
            ],
            stateSave: false,
            ajax: {
                url: "guest/tables",
                dataSrc: Defaults.global.dt.ajax.dataSrc("tables"),
            },
            columnDefs: Defaults.global.dt.getColumns([
                {
                    title: "Cuenta",
                    data: "count",
                    visible: false,
                },
                {
                    title: "Lado",
                    data: "side",
                    visible: false,
                },
                {
                    title: "Mesa",
                    data: "table_number",
                    render(data, type) {
                        if (type == "display") {
                            return ``;
                        }
                        return data;
                    },
                },
                {
                    orderable: false,
                    title: "Nombre",
                    data: "nombre",
                    render(nombre, type, { apellidos, companion }) {
                        if (type == "display" || type === "export") {
                            const strcompanion = companion ? "(Acompañante)" : "";
                            return `${nombre} ${apellidos !== null && apellidos !== void 0 ? apellidos : ""} ${strcompanion}`;
                        }
                        return nombre + " " + (apellidos !== null && apellidos !== void 0 ? apellidos : "");
                    },
                },
                {
                    orderable: false,
                    title: "Invitación",
                    data: "name",
                },
                {
                    orderable: false,
                    title: "Asientos",
                    data: "confirmed",
                },
                {
                    data: null,
                    render(data, type, { invite_id: id }) {
                        if (type == "display") {
                            const code = btoa(id);
                            const url = Defaults.global.publicUrl + `/invitado?i=${code}`;
                            return (`<div style="width: max-content">` +
                                `<a href="${url}" target="_blank" class="btn btn-sm"><i class="fas fa-external-link-alt"></i></a>` +
                                `</div>`);
                        }
                        if (type == "export") {
                            return "";
                        }
                        return null;
                    },
                },
            ]),
            order: [[1, "asc"]],
            pageLength: 30,
            rowGroup: {
                dataSrc: ["side", "table_number"],
                startRender(api, group, level) {
                    if (level == 0) {
                        group = group.charAt(0).toUpperCase() + group.slice(1);
                        return `<span class="text-muted text-sm">${group}</span>`;
                    }
                    else {
                        const count = api
                            .rows()
                            .data()
                            .filter(function (data) {
                            return data["table_number"] == group;
                        })
                            .count();
                        const sumConfirmed = Object.values(api
                            .rows()
                            .data()
                            .filter(function (data) {
                            return data["table_number"] == group;
                        })
                            .reduce((a, b) => {
                            if (!a[b.invite_id]) {
                                a[b.invite_id] = 0;
                            }
                            a[b.invite_id] = a[b.invite_id] || b.confirmed;
                            return a;
                        }, {})).reduce((a, b) => {
                            return a + b;
                        }, 0);
                        return `<span class="text-muted text-sm">Mesa #${group} | ${sumConfirmed.toString()} asientos</span>`;
                    }
                },
            },
            initComplete(settings, response, api) {
                const totals = response.data.tables.length;
                const novio = Object.values(response.data.tables
                    .filter(function (data) {
                    return data["side"] == "novio";
                })
                    .reduce((a, b) => {
                    if (!a[b.invite_id]) {
                        a[b.invite_id] = 0;
                    }
                    a[b.invite_id] = a[b.invite_id] || b.confirmed;
                    return a;
                }, {})).reduce((a, b) => {
                    return a + b;
                }, 0);
                const novia = Object.values(response.data.tables
                    .filter(function (data) {
                    return data["side"] == "novia";
                })
                    .reduce((a, b) => {
                    if (!a[b.invite_id]) {
                        a[b.invite_id] = 0;
                    }
                    a[b.invite_id] = a[b.invite_id] || b.confirmed;
                    return a;
                }, {})).reduce((a, b) => {
                    return a + b;
                }, 0);
                $("#txtTotal").text(novio + novia);
                $("#txtNovio").text(novio);
                $("#txtNovia").text(novia);
            },
        });
    }
}
window["saveTable"] = Mesas.saveTable;
